import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { ContratoContratanteCabeceraDTO } from '../../models/contrato-afilmed/contrato-contratante-cabecera.model';

@Injectable({
  providedIn: 'root',
})
export class ContratoContratanteCabeceraService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.CONTRATOS_USER_DATOS_FORMULARIO_CONTRATANTE}`;

  constructor(private http: HttpClient) {} 

  getCabeceraContratante(
    numeroContrato: string
  ): Observable<ContratoContratanteCabeceraDTO | null> {
    const id = String(numeroContrato ?? '').trim();
    if (!id) {
      return of(null);
    }
    const params = new HttpParams().set('numeroContrato', id);
    return this.http.get<unknown>(this.apiUrl, { params }).pipe(
      map((raw) => this.normalizarRespuesta(raw)),
      catchError(() => of(null))
    );
  }

  normalizarRespuesta(raw: unknown): ContratoContratanteCabeceraDTO | null {
    if (raw == null) {
      return null;
    }
    let obj: any = raw;
    if (Array.isArray(obj)) {
      obj = obj[0];
    }
    if (obj && typeof obj === 'object' && 'data' in obj && obj.data != null) {
      obj = Array.isArray(obj.data) ? obj.data[0] : obj.data;
    }
    if (obj && typeof obj === 'object' && 'content' in obj && obj.content != null) {
      obj = Array.isArray(obj.content) ? obj.content[0] : obj.content;
    }
    if (!obj || typeof obj !== 'object') {
      return null;
    }
    const str = (a: string, b: string): string | undefined => {
      const v = obj[a] ?? obj[b];
      if (v === null || v === undefined) {
        return undefined;
      }
      const t = String(v).trim();
      return t || undefined;
    };
    const pickOptNull = (
      camel: string,
      pascal: string
    ): string | null | undefined => {
      if (!(camel in obj) && !(pascal in obj)) {
        return undefined;
      }
      const v = obj[camel] ?? obj[pascal];
      if (v === null || v === undefined) {
        return null;
      }
      const t = String(v).trim();
      return t || null;
    };

    const out: ContratoContratanteCabeceraDTO = {
      codigoAsesor: str('codigoAsesor', 'CodigoAsesor'),
      tipoDocumento: str('tipoDocumento', 'TipoDocumento'),
      numeroDocumento: str('numeroDocumento', 'NumeroDocumento'),
      primerNombre: str('primerNombre', 'PrimerNombre'),
      segundoNombre: pickOptNull('segundoNombre', 'SegundoNombre'),
      primerApellido: str('primerApellido', 'PrimerApellido'),
      segundoApellido: pickOptNull('segundoApellido', 'SegundoApellido'),
      fechaNacimiento: str('fechaNacimiento', 'FechaNacimiento'),
      estadoCivil: pickOptNull('estadoCivil', 'EstadoCivil'),
      genero: pickOptNull('genero', 'Genero'),
      estratoSocial: pickOptNull('estratoSocial', 'EstratoSocial'),
      nacionalidad: pickOptNull('nacionalidad', 'Nacionalidad'),
      profesion: pickOptNull('profesion', 'Profesion'),
      deseaCorrespondenciaFisica:
        'deseaCorrespondenciaFisica' in obj || 'DeseaCorrespondenciaFisica' in obj
          ? obj.deseaCorrespondenciaFisica ?? obj.DeseaCorrespondenciaFisica
          : undefined,
      email: str('email', 'Email'),
      ocupacion: pickOptNull('ocupacion', 'Ocupacion'),
      telefonoCelular: str('telefonoCelular', 'TelefonoCelular'),
      telefonoFijo: str('telefonoFijo', 'TelefonoFijo'),
      contratanteLinea: str('contratanteLinea', 'ContratanteLinea'),
    };

    const tieneAlgo =
      !!out.codigoAsesor ||
      !!out.tipoDocumento ||
      !!out.numeroDocumento ||
      !!out.primerNombre ||
      !!out.primerApellido ||
      !!out.email ||
      !!out.fechaNacimiento ||
      out.genero != null ||
      out.estadoCivil != null ||
      out.segundoNombre !== undefined ||
      out.segundoApellido !== undefined ||
      out.estratoSocial != null ||
      out.nacionalidad != null ||
      out.profesion != null ||
      out.ocupacion != null ||
      out.deseaCorrespondenciaFisica !== undefined;
    return tieneAlgo ? out : null;
  }
}
